import React, { useState, useEffect } from "react";
import "./Sidebar.scss";
import { NavLink } from "react-router-dom";
import { Triangle } from "../../../assets/images";

const Sidebar = ({
  collections = [],
  activeAddress,
  onSelect,
  title,
  Image1,
  description,
  MEDIA_RESOURCES_CONTRACTS = [],
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeCollection, setActiveCollection] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const [isPalestineOpen, setIsPalestineOpen] = useState(true);
  const [isMediaOpen, setIsMediaOpen] = useState(false);

  useEffect(() => {
    if (collections.length > 0 && !activeCollection) {
      handleClick(collections[0]);
    }
  }, [collections]);

  useEffect(() => {
    if (activeAddress) {
      const found = collections.find((c) => c.address === activeAddress);
      if (found) setActiveCollection(found);
    }
  }, [activeAddress, collections]);

  const handleClick = (collection, group) => {
    setActiveCollection(collection);
    if (onSelect) onSelect(collection);

    if (group === "palestine") setIsMediaOpen(false);
    if (group === "media") setIsPalestineOpen(false);
  };

  const text = description || "No description available";
  const isLong = text.length > 300;

  return (
    <>
      <button className="arc-sidebar-toggle" onClick={() => setIsOpen(true)}>
        ☰
      </button>

      {isOpen && (
        <div className="arc-overlay" onClick={() => setIsOpen(false)} />
      )}

      <aside className={`arc-sidebar ${isOpen ? "arc-open" : ""}`}>
        <button className="arc-close-btn" onClick={() => setIsOpen(false)}>
          ✕
        </button>

        <img
          className="arc-sidebar-image"
          src={Image1}
          alt={activeCollection?.name || "Collection"}
        />
        <div className="arc-scroll-content">
          <div className="cont-description">
            {activeCollection?.name && (
              <h3 className="arc-collection-name">{activeCollection.name}</h3>
            )}
            <p className={`arc-description ${expanded ? "expanded" : ""}`}>
              {text}
            </p>
            {isLong && (
              <span
                className="arc-read-more-btn"
                onClick={() => setExpanded(!expanded)}
              >
                {expanded ? "Read Less" : "Read More"}
              </span>
            )}
          </div>

          <div className="arc-sidebar-container">
            <div className="arc-container">
              <ul className="arc-sidebar-ul">
                <li
                  className={`arc-sidebar-title-li ${isPalestineOpen ? "hasopenicon" : "closed"}`}
                  onClick={() => setIsPalestineOpen((p) => !p)}
                >
                  <span className="arc-title-icon">
                    {isPalestineOpen ? (
                      <img
                        src={Triangle}
                        alt="open"
                        className="arc-open-icon"
                      />
                    ) : (
                      <span></span>
                    )}
                  </span>
                  Palestine Archive Collection
                </li>
                {isPalestineOpen &&
                  collections.map((collection, index) => {
                    const isActive =
                      activeCollection?.address?.toLowerCase() ===
                      collection.address?.toLowerCase();
                    return (
                      <li
                        key={index}
                        className={`arc-sidebar-item ${isActive ? "arc-active" : ""}`}
                        onClick={() => handleClick(collection, "palestine")}
                      >
                        <span
                          className={`arc-circle ${isActive ? "filled" : ""}`}
                        ></span>
                        {collection.name ||
                          collection.address.slice(0, 6) + "..."}
                      </li>
                    );
                  })}

                <li
                  className={`arc-sidebar-title-li ${isMediaOpen ? "hasopenicon" : "closed"}`}
                  onClick={() => setIsMediaOpen((p) => !p)}
                >
                  <span className="arc-title-icon">
                    {isMediaOpen ? (
                      <img
                        src={Triangle}
                        alt="open"
                        className="arc-open-icon"
                      />
                    ) : (
                      <span></span>
                    )}
                  </span>
                  Media Resources
                </li>
                {isMediaOpen &&
                  MEDIA_RESOURCES_CONTRACTS.map((collection, index) => {
                    const isActive =
                      activeCollection?.address?.toLowerCase() ===
                      collection.address?.toLowerCase();
                    return (
                      <li
                        key={index}
                        className={`arc-sidebar-item ${isActive ? "arc-active" : ""}`}
                        onClick={() => handleClick(collection, "media")}
                      >
                        <span
                          className={`arc-circle ${isActive ? "filled" : ""}`}
                        ></span>
                        {collection.name}
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
        </div>

        <div className="arc-back">
          <NavLink
            className="arc-back-btn2"
            onClick={() => window.history.back()}
          >
            ◀ Back
          </NavLink>
          <NavLink
            className="arc-back-btn2"
            onClick={() => {
              if (collections.length > 0) {
                handleClick(collections[0], "palestine");
                setIsPalestineOpen(true);
                setIsMediaOpen(false);
              }
            }}
          >
            Reset
          </NavLink>
        </div>
      </aside>
    </>
  );
};

export default React.memo(Sidebar);
